import { AutoComplete } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { useTranslation } from "react-i18next";

const TICKET_TYPE_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const ticketTypeService = new MainApi(TICKET_TYPE_ROUTE);

const translationPath = "page.settings.crm.ticketAutoInactivityRules.";

export const TicketType = () => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        params={{ identifier: "TICKET_TYPE" }}
        getOptionLabel={(option) => {
          return option.name;
        }}
        size="small"
        label={t(translationPath + "ticket_type")}
        name="ticketType"
        request={ticketTypeService.list}
      />
    </Grid>
  );
};
